<!-- Linha do tempo do lead no layout novo (17tm466frtx, 03/11/2026): mesmo desenho das Automações (M4)
     e das telas RCS — cabeçalho com ícone, um cartão por passo com o canal em chip e o status em pílula. -->
<div class="lead-seq">
  <header class="page-head">
    <div class="page-head__identity">
      <span class="page-head__icon"><i class="fa fa-history"></i></span>
      <div>
        <h1 class="page-head__title">Sequências do lead</h1>
        <p class="page-head__subtitle">Cada passo das automações que este lead percorreu, na ordem: o que saiu, por qual canal e quando.</p>
      </div>
    </div>
    <div class="page-head__actions">
      <button type="button" class="sf-btn sf-btn--secondary" (click)="back()" data-testid="btn-lead-back">
        <i class="fa fa-arrow-left"></i> Voltar
      </button>
    </div>
  </header>

  <app-skeleton *ngIf="loading" variant="text" [count]="5"
    label="Carregando as sequências do lead" data-testid="lead-sequences-loading"></app-skeleton>

  <ng-container *ngIf="sequences$ | async as sequences">
    <section class="sf-card empty" *ngIf="!sequences.length" data-testid="lead-sequences-empty">
      <i class="fa fa-bolt"></i>
      <p>Nenhuma sequência criada para este lead.</p>
      <span class="field-hint">Os passos aparecem aqui quando o lead entra numa lista com automação ativa.</span>
    </section>

    <ol class="timeline" *ngIf="sequences.length" data-testid="lead-timeline">
      <li class="step" *ngFor="let control of sequences" [ngClass]="'step--' + channelKind(control)" data-testid="lead-step">
        <span class="step__dot" aria-hidden="true"><i class="fa" [ngClass]="channelIcon(control)"
          [attr.data-testid]="isRcs(control) ? 'lead-sequence-rcs-icon' : null"></i></span>

        <article class="step__card">
          <header class="step__head">
            <span class="type" [ngClass]="'type--' + channelKind(control)">
              <i class="fa" [ngClass]="channelIcon(control)"></i> {{ channelName(control) }}
            </span>
            <span class="after"><i class="fa fa-clock-o"></i> Após {{ control.sequence?.interval }} {{ control.sequence?.interval_type?.name || (control.sequence?.interval_type_id | intervalType) }}</span>
            <span class="push"></span>
            <span class="status-pill status-pill--sm" [ngClass]="'status-pill--' + statusTone(control)" data-testid="lead-step-status">
              {{ status(control) }}
              <i *ngIf="!control.is_call4u && !control.is_webhook && !control.sent && !control.cancelled && control.queued"
                class="fa fa-question-circle" ngbTooltip="Está na fila de envio para o provedor"></i>
            </span>
          </header>

          <!-- SMS / WhatsApp / IA / RCS -->
          <ng-container *ngIf="!control.is_call4u && !control.is_webhook">
            <div class="msg" *ngIf="!isAi(control)">
              <span class="lbl">{{ isRcs(control) ? 'Mensagem RCS' : 'Mensagem' }}</span>
              <p class="msg__text">{{ isRcs(control) ? rcsText(control) : (control.message || control.sequence?.text) }}</p>
            </div>
            <p class="msg__text msg__text--ai" *ngIf="isAi(control)">Primeira mensagem via template + conversa gerada pela IA.</p>

            <!-- RCS (17tm466frtx): por onde a etapa saiu de fato. Virou SMS = aviso em texto de cliente. -->
            <div class="rcs-out" *ngIf="isRcs(control)" data-testid="lead-sequence-rcs">
              <div class="notice notice--sm" *ngIf="control.rcs?.channel === 'sms'" data-testid="lead-sequence-rcs-notice">
                <i class="fa fa-comment"></i>
                <div class="notice__body"><span><strong>{{ rcsNotice(control) }}</strong></span>
                  <span>O lead recebeu a mesma mensagem por SMS, com as regras de SMS da sua conta.</span></div>
              </div>

              <div class="msg" *ngIf="control.rcs?.channel === 'rcs' && control.rcs?.buttons?.length" data-testid="lead-sequence-rcs-buttons">
                <span class="lbl">Botões enviados</span>
                <div class="rcs-buttons">
                  <div class="rcs-button" *ngFor="let button of control.rcs.buttons">
                    <strong>{{ button.label }}</strong>
                    <a *ngIf="rcsButtonHref(button) as href; else buttonText" [href]="href" target="_blank" rel="noopener noreferrer">{{ button.resolved }}</a>
                    <ng-template #buttonText><span>{{ button.resolved }}</span></ng-template>
                  </div>
                </div>
              </div>

              <div class="msg msg--sms" *ngIf="control.rcs?.channel === 'sms' && control.rcs?.text">
                <span class="lbl">SMS que o lead recebeu</span>
                <p class="msg__text" data-testid="lead-sequence-rcs-sms-text">{{ control.rcs.text }}</p>
              </div>
            </div>

            <dl class="def-grid">
              <div class="def" *ngIf="isRcs(control)">
                <dt>Saiu por</dt>
                <dd><span class="bind-chip" [ngClass]="control.rcs?.channel === 'sms' ? 'bind-chip--warn' : control.rcs?.channel ? 'bind-chip--rcs' : 'bind-chip--muted'"
                  data-testid="lead-sequence-rcs-channel">{{ rcsChannelLabel(control) }}</span></dd>
              </div>
              <div class="def" *ngIf="control.sent || alreadySent(control) || isCancelled(control)">
                <dt>{{ isCancelled(control) ? 'Cancelada em' : 'Data/Hora envio' }}</dt>
                <dd>{{ control.updated_at | date:'dd/MM/yyyy, H:mm:ss' }}</dd>
              </div>
              <div class="def" *ngIf="!isCancelled(control) && !control.sent && !alreadySent(control)">
                <dt>{{ alreadySent(control) || control.rcs?.channel ? 'Enviado em' : 'Será enviada em' }}</dt>
                <dd>{{ control.sent_date | date:'dd/MM/yyyy, H:mm:ss' }}</dd>
              </div>
              <div class="def" *ngIf="isRcs(control) && rcsStatusLabel(control)">
                <dt>Status do {{ control.rcs?.channel === 'sms' ? 'SMS' : 'RCS' }}</dt>
                <dd>{{ rcsStatusLabel(control) }}</dd>
              </div>
              <div class="def" *ngIf="isRcs(control) && control.rcs?.read_at">
                <dt>Lido em</dt>
                <dd>{{ control.rcs.read_at | date:'dd/MM/yyyy, H:mm:ss' }}</dd>
              </div>
              <div class="def" *ngIf="isRcs(control) && control.rcs?.clicks">
                <dt>Cliques</dt>
                <dd>{{ control.rcs.clicks }}</dd>
              </div>
            </dl>

            <!-- F7.5: condição "se não ler em X h, enviar SMS" desta etapa para este lead. -->
            <div class="sub-card" *ngIf="isRcs(control) && control.read_condition as condition">
              <dl class="def-grid">
                <div class="def" data-testid="lead-sequence-read-condition">
                  <dt>Se não ler em {{ control.sequence?.rcs_read_condition?.hours ? control.sequence.rcs_read_condition.hours + ' h' : 'X h' }}</dt>
                  <dd data-testid="lead-sequence-read-condition-status">{{ readConditionLabel(condition) }}</dd>
                </div>
                <div class="def" *ngIf="condition.sms_sent_at || condition.due_at">
                  <dt>{{ condition.sms_sent_at ? 'SMS da condição em' : 'Confere em' }}</dt>
                  <dd>{{ (condition.sms_sent_at || condition.due_at) | date:'dd/MM/yyyy, H:mm:ss' }}</dd>
                </div>
                <!-- Entrega do SMS da condição pelo DLR da operadora (referência r:{id}:2). -->
                <div class="def" *ngIf="readConditionSmsStatusLabel(condition) as smsStatus">
                  <dt>Entrega do SMS da condição</dt>
                  <dd data-testid="lead-sequence-read-condition-sms-status">
                    {{ smsStatus }}<ng-container *ngIf="condition.sms_delivered_at"> em {{ condition.sms_delivered_at | date:'dd/MM/yyyy, H:mm:ss' }}</ng-container>
                  </dd>
                </div>
                <div class="def" *ngIf="condition.sms_clicks">
                  <dt>Cliques no link do SMS da condição</dt>
                  <dd data-testid="lead-sequence-read-condition-sms-clicks">{{ condition.sms_clicks }}</dd>
                </div>
                <div class="def wide" *ngIf="condition.sms_text">
                  <dt>SMS da condição</dt>
                  <dd data-testid="lead-sequence-read-condition-sms">{{ condition.sms_text }}</dd>
                </div>
                <div class="def wide" *ngIf="condition.reason && condition.status !== 'sent'">
                  <dt>Motivo</dt>
                  <dd data-testid="lead-sequence-read-condition-reason">{{ condition.reason }}</dd>
                </div>
              </dl>
            </div>

            <div class="notice notice--danger notice--sm" *ngIf="isCancelled(control) || control.cancelled" data-testid="lead-step-cancel-reason">
              <i class="fa fa-ban"></i>
              <div class="notice__body"><span><strong>Motivo:</strong> {{ control.reason || control.sent_error_reason }}</span></div>
            </div>

            <!-- Admin: o detalhe técnico do provedor e do motivo de ter virado SMS. -->
            <div class="admin" *ngIf="isAdministrator && !isAi(control)" data-testid="lead-step-admin">
              <div class="admin__head">
                <span class="lbl">Detalhe técnico</span>
                <span class="rcs-pill rcs-pill--violet"><i class="fa fa-lock"></i> Só Admin</span>
              </div>
              <dl class="def-grid">
                <div class="def wide" *ngIf="rcsReasonLabel(control)">
                  <dt>Por que virou SMS</dt>
                  <dd data-testid="lead-sequence-rcs-reason">{{ rcsReasonLabel(control) }}</dd>
                </div>
                <!-- O backend só manda o motivo técnico (código e mensagem) para o Admin. -->
                <div class="def wide" *ngIf="control.rcs?.fallback_detail">
                  <dt>Motivo técnico</dt>
                  <dd data-testid="lead-sequence-rcs-detail"><code>{{ control.rcs.fallback_detail }}</code></dd>
                </div>
                <div class="def" *ngIf="isRcs(control) && control.rcs?.channel === 'rcs'">
                  <dt>Provedor RCS</dt>
                  <dd data-testid="lead-sequence-rcs-provider">{{ control.rcs.provider_name || '—' }}</dd>
                </div>
                <div class="def" *ngIf="!isRcs(control) && control.sequence?.sequence_type !== 'whatsapp'">
                  <dt>Status no provedor</dt>
                  <dd>{{ getDeliveryStatus(control) }}</dd>
                </div>
                <!-- Só existe em entrega confirmada pela operadora: é a hora do DLR, não a do disparo. -->
                <div class="def" *ngIf="control.delivered_at">
                  <dt>Entregue em</dt>
                  <dd>{{ control.delivered_at | date:'dd/MM/yyyy, H:mm:ss' }}</dd>
                </div>
                <div class="def">
                  <dt>Conta</dt>
                  <dd [attr.data-testid]="isRcs(control) ? 'lead-sequence-rcs-account' : null">{{ isRcs(control) ? (control.rcs?.provider_account_name || '—') : (control.provider_account_name || '—') }}</dd>
                </div>
                <div class="def" *ngIf="!isRcs(control)">
                  <dt>Operadora</dt>
                  <dd>{{ control.carrier || '—' }}</dd>
                </div>
              </dl>
            </div>

            <div class="actions" *ngIf="isAi(control) && conversationId">
              <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" (click)="openConversation()" data-testid="btn-open-lead-conversation">
                <i class="fa fa-whatsapp"></i> Ver conversa com IA
              </button>
            </div>
          </ng-container>

          <!-- Webhook -->
          <ng-container *ngIf="control.is_webhook">
            <dl class="def-grid">
              <div class="def wide">
                <dt>URL do webhook</dt>
                <dd><code class="url">{{ control.webhook_url || '—' }}</code></dd>
              </div>
              <div class="def wide" *ngIf="control.webhook_description">
                <dt>Descrição</dt>
                <dd>{{ control.webhook_description }}</dd>
              </div>
              <div class="def">
                <dt>Agendado para</dt>
                <dd>{{ control.sent_date | date:'dd/MM/yyyy, H:mm:ss' }}</dd>
              </div>
              <div class="def" *ngIf="control.sent_at">
                <dt>Disparado em</dt>
                <dd>{{ control.sent_at | date:'dd/MM/yyyy, H:mm:ss' }}</dd>
              </div>
              <div class="def" *ngIf="control.webhook_tries !== null && control.webhook_tries !== undefined">
                <dt>Tentativas</dt>
                <dd>{{ control.webhook_tries }}</dd>
              </div>
              <div class="def" *ngIf="control.webhook_http_status">
                <dt>HTTP status</dt>
                <dd><span class="status-pill status-pill--sm" [ngClass]="control.webhook_http_status >= 200 && control.webhook_http_status < 300 ? 'status-pill--ok' : 'status-pill--danger'">{{ control.webhook_http_status }}</span></dd>
              </div>
            </dl>
          </ng-container>

          <!-- Call4U - Mensagem de Voz -->
          <ng-container *ngIf="control.is_call4u">
            <div class="msg">
              <span class="lbl">Áudio</span>
              <p class="msg__text">
                {{ control.call4u_audio_title || 'Sem título' }}
                <span class="chip">{{ control.call4u_audio_type === 'tts' ? 'TTS' : 'Upload' }}</span>
                <span class="chip chip--muted" *ngIf="control.call4u_audio_duration">{{ control.call4u_audio_duration }}s</span>
              </p>
            </div>
            <dl class="def-grid">
              <div class="def">
                <dt>Horário do disparo</dt>
                <dd>{{ control.sent_at ? (control.sent_at | date:'dd/MM/yyyy, H:mm:ss') : (control.sent_date | date:'dd/MM/yyyy, H:mm:ss') }}</dd>
              </div>
              <div class="def" *ngIf="control.callback_received_at">
                <dt>Retorno PABX</dt>
                <dd>{{ control.callback_received_at | date:'dd/MM/yyyy, H:mm:ss' }}</dd>
              </div>
              <div class="def">
                <dt>Tentativas</dt>
                <dd>{{ control.call4u_tries }} / {{ control.call4u_max_attempts }}</dd>
              </div>
              <div class="def">
                <dt>Intervalo entre tentativas</dt>
                <dd>{{ control.call4u_retry_interval }} min</dd>
              </div>
              <div class="def" *ngIf="control.call4u_pabx_status">
                <dt>Resultado</dt>
                <dd>{{ control.call4u_pabx_label }}</dd>
              </div>
              <div class="def" *ngIf="control.call4u_duration">
                <dt>Duração da ligação</dt>
                <dd>{{ control.call4u_duration }}s</dd>
              </div>
              <div class="def" *ngIf="control.call4u_listened">
                <dt>Áudio ouvido</dt>
                <dd>{{ control.call4u_listened }}%</dd>
              </div>
              <div class="def" *ngIf="control.call4u_dtmf">
                <dt>Retorno do usuário (DTMF)</dt>
                <dd>Tecla {{ control.call4u_dtmf }}</dd>
              </div>
            </dl>
          </ng-container>
        </article>
      </li>
    </ol>
  </ng-container>
</div>
